import { useState, type SyntheticEvent } from "react";
import { Navigate, useNavigate } from "react-router";

import { Button, TextField } from "../../components/ui/Controls";
import { AlertBanner } from "../../components/ui/Feedback";
import { apiErrorMessage, useAuth } from "../../lib/auth";
import { usePageTitle } from "../../route-meta";

export function MfaPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [recoveryMode, setRecoveryMode] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  usePageTitle("İki adımlı doğrulama");
  if (auth.pendingChallenge === undefined) return <Navigate replace to="/giris" />;
  const submit = async (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      const result = recoveryMode
        ? await auth.submitMfa({ method: "recovery_code", code })
        : await auth.submitMfa({ method: "totp", code });
      setCode("");
      if (result.status === "authenticated") void navigate("/genel-bakis", { replace: true });
    } catch (caught) {
      setCode("");
      setError(apiErrorMessage(caught));
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="auth-layout" id="main-content" tabIndex={-1}>
      <a className="skip-link" href="#main-content">
        Ana içeriğe geç
      </a>
      <section className="card auth-card stack">
        <h1>İki adımlı doğrulama</h1>
        <p>
          {recoveryMode
            ? "Kaydettiğiniz tek kullanımlık kurtarma kodlarından birini girin."
            : "Kimlik doğrulama uygulamanızdaki kodu girin."}
        </p>
        <form
          className="form-stack"
          onSubmit={(event) => {
            void submit(event);
          }}
        >
          <TextField
            autoComplete={recoveryMode ? "off" : "one-time-code"}
            inputMode={recoveryMode ? "text" : "numeric"}
            label={recoveryMode ? "Kurtarma kodu" : "Doğrulama kodu"}
            onChange={(event) => {
              setCode(event.currentTarget.value);
            }}
            required
            value={code}
          />
          {error === undefined ? null : (
            <AlertBanner heading="Kod doğrulanamadı" tone="error">
              <p>{error}</p>
            </AlertBanner>
          )}
          <Button busy={busy} busyLabel="Kod doğrulanıyor…" type="submit">
            Kodu doğrula
          </Button>
          <Button
            onClick={() => {
              setRecoveryMode((current) => !current);
              setCode("");
            }}
            variant="quiet"
          >
            {recoveryMode ? "Doğrulama kodu kullan" : "Kurtarma kodu kullan"}
          </Button>
          <Button
            onClick={() => {
              void navigate("/giris", { replace: true });
            }}
            variant="secondary"
          >
            Girişe dön
          </Button>
        </form>
      </section>
    </main>
  );
}
